import { Box, Typography, Stack, TextField, Backdrop, CircularProgress, Button, FormControlLabel, Checkbox, Radio, RadioGroup, FormLabel } from "@mui/material";
import React from "react";
import { Context } from "../../App";
import { useNavigate } from "react-router-dom";


export default function DonCatastrophesForm() {
  const navigate = useNavigate();
  const { region, isConnected } = React.useContext(Context);
  const [load, setLoad] = React.useState(true)
  const [isAnonyme, setIsAnonyme] = React.useState(false);
  const [recurrent, setRecurrent] = React.useState(false);
  const [offrandesFederale, setOffrandesFederale] = React.useState([]);
  
  const total = React.useMemo(() => offrandesFederale.map(off=>off.montant).reduce((acc, val) => {
    const num = Number(val);
    return acc + (isNaN(num) ? 0 : num);
  }, 0), [offrandesFederale]);

  function handleSubmit(e) {
    e.preventDefault();
    setLoad(true);
    console.log("Processing add to cart for total:", total);
    fetch(process.env.REACT_APP_ESDRAS_API_URL.concat('/panier/add?model=Don'), {method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${isConnected ? localStorage.getItem('token') : localStorage.getItem('anonUserId') || ''}`
      }, 
      body: JSON.stringify({
          isAnonyme,
          user: isConnected ? localStorage.getItem('user') : localStorage.getItem('anonUserId'),
          recurrent,
          type: 'Catastrophes naturelles',
          offrande_spe_feam: offrandesFederale.filter(off => off.montant > 0),
          region
      })
    }).then(async (res) => {
      const token = res.headers.get('x-auth-token');
      if (token) localStorage.setItem('token', token);
      if(res.ok) {
        const data = await res.json();
        return data;
      } else {
        const error = await res.text();
        throw new Error(`API error: ${res.status} - ${error}`);
      }
    }).then((data) => {
      console.log(" response:", data);
      setLoad(false);
      //redirect to cart
      navigate('/panier');
    }).catch((err) => {
      console.error("Error during add to cart:", err);
      setLoad(false);
    });
  }


  React.useEffect(()=>{
    setLoad(true);
    const query = new URLSearchParams({ region, exercice: new Date().getFullYear() }).toString();

    fetch(process.env.REACT_APP_THYBA_API_URL.concat('/public/catastrophes?'+ query), {method: 'GET'})
    .then(async(res) => {
      const token = res.headers.get('x-auth-token');
      if (token) localStorage.setItem('token', token);
      if(!res.ok) throw new Error(res.statusText);
      const json = await res.json();
      const comptes = json.map(inst => [inst, inst.sous_postes.map(sp => sp.activated ? {libelle: sp.libelle, montant: 0, compte: inst.num} : null).filter(Boolean)].flat()).flat();
      setOffrandesFederale(comptes.map(inst => ({libelle: inst.libelle, montant: 0, compte: inst.num})));
      setLoad(false);
    })
    .catch((err) => {
      console.error("Error fetching institutions:", err);
    }).finally(() => setLoad(false));
  }, [region])

  return (
    <Box component='form' onSubmit={handleSubmit} display={"flex"} flexDirection="column" gap={2} sx={{ mb:4, px: { xs: 2, sm: 0 } }}>
      <Typography textAlign="center" variant="h1" color="focus" sx={{ fontSize: { xs: '1.75rem', sm: '2.5rem' }, mb: 2 }}>Catastrophes naturelles</Typography>

      {offrandesFederale.map((off, index) => (
        <Stack key={index} direction="row" gap={2} alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ minWidth: 150 }}>{off.libelle}</Typography>
          <TextField size="small" type="number" value={off.montant} sx={{maxWidth: {xs: '100px', md: '150px', lg: '200px'}}}
          InputProps={{endAdornment: <Typography variant="body2" color="textSecondary">€</Typography>}}
          onFocus={()=> {if(off.montant===0) setOffrandesFederale(previous=> previous.map(el=> el.compte===off.compte && el.libelle===off.libelle ? {...off, montant: ''} : el))}}
          onBlur={()=>{ if(off.montant==='') setOffrandesFederale(previous => previous.map(el=> el.compte===off.compte && el.libelle===off.libelle ? {...el, montant: 0} : el))}}
          onChange={(e) => {
            const newOffrandes = [...offrandesFederale];
            if(!isNaN(parseFloat(e.target.value))) {
              newOffrandes[index].montant = Math.round(Number(e.target.value)*100)/100;
              setOffrandesFederale(newOffrandes);
            } else if(e.target.value === '') {
              newOffrandes[index].montant = '';
              setOffrandesFederale(newOffrandes);
            }
          }} />
        </Stack>
      ))}

      <FormControlLabel control={
        <Checkbox checked={isAnonyme} onChange={(e) => setIsAnonyme(e.target.checked)} />
      } label="Don anonyme" sx={{alignSelf:'center'}} />

      <RadioGroup row value={recurrent} onChange={(e) => setRecurrent(e.target.value === 'true')} sx={{alignSelf:'center', alignItems:'center'}}>
        <FormLabel id="don-type-label" sx={{fontWeight:'bold', marginRight:2, color:'focus.main'}}>Type de don:</FormLabel>
        <FormControlLabel value={true} control={<Radio color="focus" />} label="Récurrent" sx={{color:'focus.main'}} />
        <FormControlLabel value={false} sx={{color:'focus.main'}} control={<Radio color='focus' />} label="Ponctuel" />
      </RadioGroup>

      <Typography variant="h5" color='primary' sx={{fontWeight:'bold', marginBlock:2, marginLeft: { xs: 0, sm: 5 }, textAlign: { xs: 'center', sm: 'left' }, fontSize: { xs: '1.25rem', sm: '1.5rem' }}}>TOTAL DON: {total?.toFixed(2)}€</Typography> 

      <Button type="submit" variant="contained" color="focus" size="large" 
      sx={{alignSelf:'center', px: { xs: 4, sm: 5 }, mb:2, fontSize: { xs: '0.875rem', sm: '1rem' }, textTransform:'uppercase'}} 
      disabled={total<=0}>Ajouter au panier</Button>

      <Backdrop open={load}><CircularProgress/></Backdrop>
    </Box>
  );
}